module.exports = __webpack_public_path__ + "static/move-and-stretch-c8042937cfd51ac663b3a40bb2f32c9e.mp4";